/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createIsNotCompatibleHelper } from "@todesktop/client-util/checkIfCompatibleWithBackend.js";
import { invoke } from "./invoke.js";
/**
 * @remarks
 * This package exposes a number of methods that allow access to simple encryption and decryption of strings for storage on the local machine.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
/**
 * Whether encryption is available.
 *
 * On Linux, returns true if the app has emitted the ready event and the secret key is available.
 * On MacOS, returns true if Keychain is available.
 * On Windows, returns true once the app has emitted the ready event.
 *
 * @public
 */
export async function isEncryptionAvailable() {
    if (isNotCompatible("isEncryptionAvailable"))
        return;
    return invoke({
        namespace: "safeStorage",
        method: "isEncryptionAvailable",
        args: [],
    });
}
/**
 * Encrypts the string. This function will throw an error if encryption fails.
 *
 * @public
 */
export async function encryptString(plainText) {
    if (isNotCompatible("encryptString"))
        return;
    return invoke({
        namespace: "safeStorage",
        method: "encryptString",
        args: [plainText],
    });
}
/**
 * Decrypts the encrypted buffer obtained with safeStorage.encryptString back into a string.
 *
 * @public
 */
export async function decryptString(encrypted) {
    if (isNotCompatible("decryptString"))
        return;
    return invoke({
        namespace: "safeStorage",
        method: "decryptString",
        args: [encrypted],
    });
}
const isNotCompatible = createIsNotCompatibleHelper("safeStorage", "4.50.0");
